import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Safai from "../../../../content/people/ahsha-safai/safai.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Safai,
  React
};